import React, { useState } from 'react';
import { useAuth } from '../App';
import { userService } from '../services/api';

export default function Profile() {
  const { user, login } = useAuth();
  const [form, setForm] = useState({
    name: user.name || '',
    bio: user.bio || ''
  });
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const updated = await userService.updateProfile({
        name: form.name,
        bio: form.bio
      });
      login({ ...user, ...updated });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-card">
        <h2>Profile &amp; Settings</h2>
        <div className="subtitle">
          {user.email} &nbsp;·&nbsp;
          <span style={{ color: '#a435f0', fontWeight: 600, textTransform: 'capitalize' }}>{user.role}</span>
        </div>

        {saved && (
          <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '0.6rem 0.9rem', marginBottom: '1rem', fontWeight: 600, fontSize: '0.875rem' }}>
            Profile saved successfully!
          </div>
        )}
        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Full Name</label>
            <input
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div className="form-group">
            <label>Bio</label>
            <textarea
              value={form.bio}
              onChange={(e) => setForm({ ...form, bio: e.target.value })}
              rows={4}
              placeholder="A little about yourself..."
            />
          </div>
          <button type="submit" className="btn-primary">Save Changes</button>
        </form>
      </div>
    </div>
  );
}
